module.exports = __webpack_public_path__ + "img/import-finance-light.a6b2422.svg";